import Content from "../components/Content";

export default function Whoups404() {
  return (
    <Content>
      <div>
        <h1 className="text-7xl text-center font-acier py-20">
          Whoops! This page does not exist.
        </h1>
      </div>
    </Content>
  );
}
